var _defs, _path, _path2, _path3, _path4, _path5, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEurowagLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1044",
    "data-name": "Group 1044",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 257.135,
    height: 27.492,
    viewBox: "0 0 257.135 27.492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1600",
    "data-name": "Rectangle 1600",
    width: 257.135,
    height: 27.492,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M110,41.933l-1.54,5.078-1.54-5.078H94.745L93.2,47.011l-1.54-5.078H84.689l4.973,16.4h7.019l4.306-14.2,4.306,14.2h6.639l4.973-16.4Z",
    transform: "translate(-62.913 -31.15)",
    fill: "#00004b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M0,41.933v16.4H22.525l-1.779-5.943H6.594V47.872H19.428l-1.783-5.94Z",
    transform: "translate(0 -31.15)",
    fill: "#00004b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M0,1.428V7.367H27.4l-1.8-5.939Z",
    transform: "translate(0 -1.061)",
    fill: "#00004b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M190.209,1.223l-1.8,6.008h6.918l1.819-6.008Z",
    transform: "translate(-139.96 -0.909)",
    fill: "#00004b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M130.772,1.223h5.859l1.8,6.008h-9.465Z",
    transform: "translate(-95.806 -0.909)",
    fill: "#00004b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1043",
    "data-name": "Group 1043",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1042",
    "data-name": "Group 1042",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M389.128,17.472a23.044,23.044,0,0,1-.249,4.18,2.115,2.115,0,0,1-1.245,1.6,14.58,14.58,0,0,1-7.05,0,2.155,2.155,0,0,1-1.284-1.6,21.265,21.265,0,0,1-.275-4.18V1.223h-5.543V16.057a31.147,31.147,0,0,0,.708,7.823,5.238,5.238,0,0,0,2.883,3.5Q379.254,28.4,384.1,28.4t7.024-1.022a5.187,5.187,0,0,0,2.87-3.5,32.082,32.082,0,0,0,.681-7.823V1.223h-5.543Z",
    transform: "translate(-277.447 -0.909)",
    fill: "#00004b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M496.626,9.78a14.931,14.931,0,0,0-.6-4.665A5.1,5.1,0,0,0,493.6,2.258a10.813,10.813,0,0,0-5.294-1.035H475.66V28.086H481.2V18.363h6.054l3.944,9.723h5.9l-4.3-10.457c2.555-1,3.826-3.6,3.826-7.849m-5.91,2.4a1.886,1.886,0,0,1-1.323,1.075,12.422,12.422,0,0,1-3.3.314h-4.875V6.032h4.914a13.08,13.08,0,0,1,3.3.288,1.8,1.8,0,0,1,1.284,1.035A7.179,7.179,0,0,1,491,9.78a7.208,7.208,0,0,1-.288,2.4",
    transform: "translate(-353.351 -0.909)",
    fill: "#00004b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M594.45,1.18Q592.091,0,586.587,0T578.738,1.18a5.423,5.423,0,0,0-2.949,3.826,43.849,43.849,0,0,0-.6,8.74,43.849,43.849,0,0,0,.6,8.74,5.423,5.423,0,0,0,2.949,3.826q2.339,1.179,7.849,1.179t7.862-1.179a5.374,5.374,0,0,0,2.961-3.826,43.939,43.939,0,0,0,.6-8.74,43.849,43.849,0,0,0-.6-8.74A5.406,5.406,0,0,0,594.45,1.18m-2.346,19a2.5,2.5,0,0,1-1.363,2.084,13.021,13.021,0,0,1-4.154.433,12.865,12.865,0,0,1-4.141-.433,2.536,2.536,0,0,1-1.363-2.11,41.863,41.863,0,0,1-.314-6.408,42.1,42.1,0,0,1,.314-6.408,2.583,2.583,0,0,1,1.363-2.11,20.112,20.112,0,0,1,8.295,0A2.476,2.476,0,0,1,592.1,7.313a45.075,45.075,0,0,1,.288,6.421,45.27,45.27,0,0,1-.288,6.447",
    transform: "translate(-427.286 -0.001)",
    fill: "#00004b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M706.126,1.223,701.644,21.3h-.2L696.141,1.223H690.4L685.2,21.3H685L680.246,1.223h-5.582l6.591,26.863h6.958l4.875-17.952h.157l4.875,17.952h6.958l6.591-26.863Z",
    transform: "translate(-501.184 -0.909)",
    fill: "#00004b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M822.118,1.223l-9.094,26.863h5.582l1.913-5.779h10.47l1.953,5.779h5.74L829.587,1.223h-7.469M822,17.472l3.63-11.007h.2L829.5,17.472Z",
    transform: "translate(-603.967 -0.909)",
    fill: "#00004b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M283.524,23.29V16.922H295.75l-1.6-4.8H283.511V6.032h15.712l-1.6-4.809H277.981V28.086h22.093l-1.585-4.8Z",
    transform: "translate(-206.502 -0.909)",
    fill: "#00004b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M929.966,11.806l-1.4,4.612h5.91v6.29c-.865.079-2.018.118-3.473.118a9.972,9.972,0,0,1-4.272-.668,3.481,3.481,0,0,1-1.743-2.476,28.411,28.411,0,0,1-.432-5.91,23.63,23.63,0,0,1,.563-6.3,3.025,3.025,0,0,1,2.149-2.2,25.185,25.185,0,0,1,5.726-.432,49.736,49.736,0,0,1,5.032.406l1.323-4.35-.812-.118C936.9.537,935.5.354,934.343.222a31.355,31.355,0,0,0-3.538-.2,17.913,17.913,0,0,0-7.456,1.205,6.545,6.545,0,0,0-3.433,4.075,28.686,28.686,0,0,0-.943,8.452,29.869,29.869,0,0,0,.943,8.74A6.159,6.159,0,0,0,923.3,26.43a19.629,19.629,0,0,0,7.522,1.075,44.232,44.232,0,0,0,4.416-.262c1.664-.17,3.184-.38,4.573-.642V11.806Z",
    transform: "translate(-682.672 -0.019)",
    fill: "#00004b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEurowagLogo);
export default __webpack_public_path__ + "static/media/Eurowag_logo.012b0440760ba9971d40f5f2905e1e7f.svg";
export { ForwardRef as ReactComponent };